import React from 'react';
import timesheet from './timesheet.module.css';
import $ from 'jquery';
import CalendarDay from '../../Domain/CalendarDay.js';
import CalendarTimeFrame from '../../Domain/CalendarTimeFrame.js';
import { dateTimeHelper } from '../../Helpers/datetimeHelper.js';
import { calendarConfig } from './calendarConfig.js';
import TimeSheetEntry from '../../Domain/TimeSheetEntry.js';
import AuthService from '../../Services/authService';
import TimeFrame from './TimeFrame';
import EventDivData from './EventDivData';
import CalendarParameretObject from './CalendarParameretObject';
import ShowHoursToggler from './ShowHoursToggler';
import FeeTypesEnum from '../../Enums/FeeTypesEnum.js';

export default class CalendarWeek extends React.Component {
  static defaultProps = {
    timeSheetEntryList: [],
    howManyDaysToShow: 5,
  };
  constructor(props) {
    super(props);

    this.state = {
      selectedDate: props.selectedDate,
      calendarDayList: this.getCalendarDayList(props.weekNumber, props.year, props.howManyDaysToShow),
      showBeforeWorkingHours: false,
      showAfterWorkingHours: false,
      selectedTimeFrames: [],
      isSelecting: 0,
      selectingSquareDivId: 'selectDiv',
      canUserEditTimesheet: true,
    };
    this.bound_onResize = this.bound_onResize.bind(this);
  }

  renderShowHourTogglers() {
    return (
      <div>
        <ShowHoursToggler
          className={timesheet.showBeforeHours}
          onClick={this.toggleBeforehours.bind(this)}
          shown={this.state.showBeforeWorkingHours}
        />
        <ShowHoursToggler
          className={timesheet.showAfterHours}
          onClick={this.toggleAfterhours.bind(this)}
          shown={this.state.showAfterWorkingHours}
        />
      </div>
    );
  }

  renderTimeFrame(calendarTimeframe, index, calendarDay) {
    return (
      <TimeFrame
        calendarTimeframe={calendarTimeframe}
        showBeforeWorkingHours={this.state.showBeforeWorkingHours}
        showAfterWorkingHours={this.state.showAfterWorkingHours}
        dailyWorkStartTime={calendarConfig.dailyWorkStartTime}
        dailyWorkEndTime={calendarConfig.dailyWorkEndTime}
        intervalToShowInMinutes={calendarConfig.intervalToShowInMinutes}
        onClick={(e) => this.TimeFrameOnClick(calendarDay, calendarTimeframe)}
        key={`tfkey${index}`}
      />
    );
  }

  getEntryClassName(timeSheetEntry) {
    return timeSheetEntry.freelancerLineItemId ? timesheet.entryDivUneditable : timesheet.entryDivEditable;
  }

  // Entry colour by task category. Jira worklogs and outsourced lines are keyed by their
  // own flags; the fixed activity tasks are keyed by task name (Task.Name is UNIQUE, so it
  // is stable across environments — unlike TaskIds). Falls back to serviceType, then navy.
  getEntryColor(timeSheetEntry) {
    if (timeSheetEntry.freelancerLineItemId) return 'var(--ink-3)'; // outsourced / uneditable
    if (timeSheetEntry.jiraWorklogId) return 'var(--navy)'; // Synced from Jira

    const colorByTaskName = {
      'CSR - Community / Social': 'var(--violet)',
      'CSR - Environment': 'var(--dgreen)',
      'CSR - Other': 'var(--sky)',
      'Employee Engagement Activity': 'var(--gold)',
      'IT_Admin Tasks': 'oklch(0.6 0.09 205)',
      'Paid Break': 'var(--ink-3)',
      PTO: 'var(--green)',
      'Public Holiday': 'oklch(0.62 0.12 350)',
      'Test task': 'oklch(0.62 0.03 260)',
    };
    const byName = colorByTaskName[(timeSheetEntry.taskName || '').trim()];
    if (byName) return byName;

    if (timeSheetEntry.taskId === 106) return 'var(--green)'; // PTO (id fallback)
    switch (timeSheetEntry.serviceType) {
      case FeeTypesEnum.IT:
        return 'oklch(0.6 0.09 205)';
      case FeeTypesEnum.DataQuality:
      case FeeTypesEnum.DQ:
        return 'var(--dgreen)';
      default:
        return 'var(--navy)';
    }
  }

  getEntryTitle(timeSheetEntry) {
    if (timeSheetEntry.freelancerLineItemId) return `FreelancerLineItemId: ${timeSheetEntry.freelancerLineItemId}`;
    if (!timeSheetEntry.serviceType) return '';
    return timeSheetEntry.serviceType;
  }

  renderDayHeader(calendarDay) {
    const className = `${timesheet.strippedrow} ${timesheet.dayHeader} datatableheaderTS text-center `;

    return (
      <div
        className={className}
        id={`${calendarDay.divId}header`}
      >
        {dateTimeHelper.getWeekDay(calendarDay.Date)}
        <br />
        {dateTimeHelper.getUSFormattedDate(calendarDay.Date, '.')}
      </div>
    );
  }

  renderOneDay(calendarDay, index) {
    return (
      <div
        className={timesheet.day}
        key={calendarDay.Date}
        id={calendarDay.divId}
        style={{ width: `${100 / this.props.howManyDaysToShow}%` }}
      >
        {this.renderDayHeader(calendarDay)}
        <div id={`${calendarDay.divId}timeframes`}>
          {/* Timeframes*/}
          {calendarDay.TimeFrameList.map((calendarTimeframe, index) =>
            this.renderTimeFrame(calendarTimeframe, index, calendarDay)
          )}
        </div>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState({
        //weekNumber: nextProps.weekNumber,
        //year: nextProps.year,
        selectedDate: nextProps.selectedDate,
        calendarDayList: this.getCalendarDayList(nextProps.weekNumber, nextProps.year, nextProps.howManyDaysToShow),
      });
    }
  }

  componentDidMount() {
    AuthService.getInstance().listenSwitchUserEvent(this.ChangeUserCallback);
    const toggler = $('#divToggleMenu')[0];
    if (toggler !== undefined) {
      toggler.addEventListener('click', this.showEntriesDelayed.bind(this));
    }
    this.showEntriesDelayed();
  }

  showEntriesDelayed() {
    setTimeout(() => this.showEntries(this.state.calendarDayList, this.props.timeSheetEntryList), 100);
  }

  componentDidUpdate(prevProps) {
    if (prevProps === this.props) {
      return;
    }
    window.addEventListener('resize', this.bound_onResize);
    this.showEntriesDelayed();
    this.showEntries(this.state.calendarDayList, this.props.timeSheetEntryList);
  }

  componentWillUnmount() {
    const toggler = $('#divToggleMenu')[0];
    if (toggler !== undefined) {
      toggler.removeEventListener('click', () =>
        this.showEntries(this.state.calendarDayList, this.props.timeSheetEntryList)
      );
    }
    window.removeEventListener('resize', this.bound_onResize);
  }

  bound_onResize() {
    this.showEntries(this.state.calendarDayList, this.props.timeSheetEntryList);
  }

  sendNewEntry = (newEntry) => {
    this.props.newEntryCallback(newEntry);
  };

  getCalendarDayList(weekNumber, year, howManyDaysToShow) {
    const timeFrames = this.getTimeFramesToShow(
      calendarConfig.dailyStartTime,
      calendarConfig.dailyEndTime,
      calendarConfig.intervalToShowInMinutes
    );
    const actMonday = dateTimeHelper.getMondayOfISOWeek(weekNumber, year);

    const days = [];
    let actDate = actMonday;

    for (let i = 0; i < howManyDaysToShow; i++) {
      days.push(new CalendarDay(actDate, JSON.parse(JSON.stringify(timeFrames))));
      actDate = new Date(actDate.getFullYear(), actDate.getMonth(), actDate.getDate() + 1);
    }
    return days;
  }

  getTimeFramesToShow(dailyStartTime, dailyEndTime, intervalToShowInMinutes) {
    const timeFrames = [];

    let i = dateTimeHelper.convertTimeToMinutes(dailyStartTime);
    const endTimeinMinutes = dateTimeHelper.convertTimeToMinutes(dailyEndTime);

    while (i < endTimeinMinutes) {
      timeFrames.push(new CalendarTimeFrame(i, i + intervalToShowInMinutes));
      i += intervalToShowInMinutes;
    }

    return timeFrames;
  }

  showEntries(calendarDayList, timeSheetEntryList) {
    if (timeSheetEntryList == null || timeSheetEntryList.length === 0) {
      return;
    }

    const calendarParameters = new CalendarParameretObject(
      calendarDayList,
      this.state.showBeforeWorkingHours,
      this.state.showAfterWorkingHours
    );

    // Remove overflowing timesheet entries from previous week's Sunday
    const filteredTimesheetEntriesList = timeSheetEntryList.filter(
      (f) => dateTimeHelper.dateDiffInDays(this.state.selectedDate, new Date(f.startDate)) >= 0
    );
    filteredTimesheetEntriesList.forEach((actEntry) => {
      actEntry.calculateShownTimePosition(
        calendarParameters,
        this.state.showBeforeWorkingHours,
        this.state.showAfterWorkingHours
      );

      const entryDiv = $(`#${actEntry.divId}`)[0];

      if (actEntry.showEntry) {
        const dayDiv = $(`#div${actEntry.tempStartDate.split('.').join('_')}`)[0];

        if (dayDiv !== undefined && entryDiv !== undefined) {
          const eventDivData = new EventDivData(actEntry, calendarParameters, dayDiv.offsetLeft);

          eventDivData.applyEventDivDataForDiv(entryDiv); //positioning the entryDiv
          entryDiv.style.visibility = 'visible';
        }
      } else if (entryDiv !== undefined) {
        entryDiv.style.visibility = 'hidden';
      }
    });
  }

  toggleBeforehours() {
    const showBeforeWorkingHours = this.state.showBeforeWorkingHours;
    this.setState(
      {
        showBeforeWorkingHours: !showBeforeWorkingHours,
      },
      this.showEntriesDelayed(this.state.calendarDayList, this.props.timeSheetEntryList)
    );
  }

  toggleAfterhours() {
    const showAfterWorkingHours = this.state.showAfterWorkingHours;
    this.setState(
      {
        showAfterWorkingHours: !showAfterWorkingHours,
      },
      this.showEntriesDelayed(this.state.calendarDayList, this.props.timeSheetEntryList)
    );
  }

  ChangeUserCallback = () => {};

  ChangeTimeFramePropertyInDayList(calendarDay, calendarTimeFrame, property, newValue) {
    const newdayList = this.state.calendarDayList.slice();

    let timeFrameToModify;

    for (
      let i = 0;
      i < newdayList.length && (typeof timeFrameToModify === 'undefined' || timeFrameToModify === null);
      i++
    ) {
      for (
        let j = 0;
        j < newdayList[i].TimeFrameList.length &&
        (typeof timeFrameToModify === 'undefined' || timeFrameToModify === null);
        j++
      ) {
        if (
          newdayList[i].Date === calendarDay.Date &&
          newdayList[i].TimeFrameList[j].StartTime === calendarTimeFrame.StartTime
        ) {
          timeFrameToModify = newdayList[i].TimeFrameList[j];
        }
      }
    }

    timeFrameToModify[property] = newValue;

    return newdayList;
  }

  /* Visualize timeframe selection when selection multiple timeframes in a square or clicking on a single timeframe */

  TimeFrameOnClick = (calendarDay, calendarTimeFrame) => {
    // $(`#${this.state.selectingSquareDivId}`)[ 0 ].hidden = 1;
    // this.setState({
    //     calendarDayList: this.ChangeTimeFramePropertyInDayList(calendarDay, calendarTimeFrame, "IsSelected", !calendarTimeFrame.IsSelected),
    //     isSelecting: 0
    // });

    const newEntry = new TimeSheetEntry(
      dateTimeHelper.getFormattedDate(calendarDay.Date, '.'),
      dateTimeHelper.getFormattedDate(calendarDay.Date, '.'),
      dateTimeHelper.convertMinutesToTime(calendarTimeFrame.StartTime),
      dateTimeHelper.convertMinutesToTime(calendarTimeFrame.StartTime + calendarConfig.intervalToShowInMinutes)
    );
    this.sendNewEntry(newEntry);
  };

  renderExistingTimesheetEntries(timeSheetEntry, index) {
    const dayEndOfTheEntry = dateTimeHelper
      .getDateFromDateString(`${timeSheetEntry.endDate} ${timeSheetEntry.endTime}`)
      .getTime();
    const dayStartOfTheEntry = dateTimeHelper
      .getDateFromDateString(`${timeSheetEntry.endDate} ${timeSheetEntry.endTime}`)
      .getTime();
    const startOfTheDay = dateTimeHelper.startOfTheDay(this.state.selectedDate).getTime();
    const endOfTheDay = dateTimeHelper.endOfTheDay(dateTimeHelper.addDaysToDate(this.state.selectedDate, 7)).getTime();
    // const diff = dateTimeHelper.dateDiffInDays(this.state.selectedDate, new Date(timeSheetEntry.tempStartDate));

    // if (diff < 0) {
    //   console.log("no: " + index);
    //   return null;
    // }
    if (dayEndOfTheEntry >= startOfTheDay && dayStartOfTheEntry < endOfTheDay) {
      return (
        <div
          key={timeSheetEntry.divId}
          className={`${timesheet.entryDiv} pointer ${this.getEntryClassName(timeSheetEntry)}`}
          id={timeSheetEntry.divId}
          style={{ '--pc': this.getEntryColor(timeSheetEntry) }}
          onClick={(e) => this.sendNewEntry(timeSheetEntry)}
          data-toggle='tooltip'
          data-placement='top'
          title={this.getEntryTitle(timeSheetEntry)}
        >
          {timeSheetEntry.text}
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <div id='divCalendarWeek'>
        {this.renderShowHourTogglers()}
        <div
          className={timesheet.main}
          id='divTimesheetMain'
        >
          {this.state.calendarDayList.map(this.renderOneDay.bind(this))}
          {this.props.timeSheetEntryList.map(this.renderExistingTimesheetEntries.bind(this))}
        </div>
        <div
          id='selectDiv'
          hidden
          className={timesheet.selectDiv}
        />
      </div>
    );
  }

  // WeekOnMouseUp = (e) =>
  // {
  //     if (!this.state.isSelecting)
  //     {
  //         return;
  //     }
  //     let i;
  //     let j;
  //     const selectDivWidth = $(`#${this.state.selectingSquareDivId}`)[ 0 ].offsetWidth;
  //     const selectDivHeight = $(`#${this.state.selectingSquareDivId}`)[ 0 ].offsetHeight;
  //     if (selectDivWidth < 3 && selectDivHeight < 3)
  //     {
  //         this.setState({ isSelecting: 0 });
  //         return;
  //     }

  //     const newCalendarDay = this.state.calendarDayList.slice();
  //     let numOfSelected = 0;

  //     for (i = 0; i < newCalendarDay.length; i++)
  //     {
  //         for (j = 0; j < newCalendarDay[ i ].TimeFrameList.length; j++)
  //         {
  //             if (this.isColliding($(`#${newCalendarDay[ i ].TimeFrameList[ j ].DivId}`), $(`#${this.state.selectingSquareDivId}`)))
  //             {
  //                 newCalendarDay[ i ].TimeFrameList[ j ].IsSelected = true;
  //                 numOfSelected++;
  //             } else
  //             {
  //                 newCalendarDay[ i ].TimeFrameList[ j ].IsSelected = false;
  //             }
  //         }

  //         this.setState({ calendarDay: newCalendarDay });
  //     }

  //     let firstSelectedDay = null;
  //     let lastSelectedDay = null;
  //     let firstSelectedTime = null;
  //     let lastSelectedTime = null;

  //     for (i = 0; i < this.state.calendarDayList.length; i++)
  //     {
  //         for (j = 0; j < this.state.calendarDayList[ i ].TimeFrameList.length; j++)
  //         {
  //             if (firstSelectedDay === null && this.state.calendarDayList[ i ].TimeFrameList[ j ].IsSelected)
  //             {
  //                 firstSelectedDay = this.state.calendarDayList[ i ].Date;
  //             }
  //             if (this.state.calendarDayList[ i ].TimeFrameList[ j ].IsSelected)
  //             {
  //                 lastSelectedDay = this.state.calendarDayList[ i ].Date;
  //             }
  //             if (firstSelectedTime === null && this.state.calendarDayList[ i ].TimeFrameList[ j ].IsSelected)
  //             {
  //                 firstSelectedTime = this.state.calendarDayList[ i ].TimeFrameList[ j ].StartTime;
  //             }
  //             if (this.state.calendarDayList[ i ].TimeFrameList[ j ].IsSelected)
  //             {
  //                 lastSelectedTime = this.state.calendarDayList[ i ].TimeFrameList[ j ].EndTime;
  //             }
  //         }
  //     }

  //     if (firstSelectedDay != null && lastSelectedDay != null &&
  //         firstSelectedTime != null && lastSelectedTime != null)
  //     {

  //         const convertedFirstSelectedDate = dateTimeHelper.getFormattedDate(firstSelectedDay, '.');
  //         const convertedLastSelectedDate = dateTimeHelper.getFormattedDate(lastSelectedDay, '.');
  //         const convertedFirstSelectedTime = dateTimeHelper.convertMinutesToTime(firstSelectedTime);
  //         const convertedLastSelectedTime = dateTimeHelper.convertMinutesToTime(lastSelectedTime);

  //         const newEntry = new TimeSheetEntry(convertedFirstSelectedDate,
  //             convertedLastSelectedDate,
  //             convertedFirstSelectedTime,
  //             convertedLastSelectedTime,
  //             "", "");

  //         this.sendNewEntry(newEntry);
  //     }

  //     this.setState({ isSelecting: 0 });
  //     if (numOfSelected > 1)
  //     {
  //         $(`#${this.state.selectingSquareDivId}`)[ 0 ].hidden = 1;
  //     }
  // };

  // ResetTimeFrameSelection ()
  // {
  //     const newdayList = this.state.calendarDayList.slice();

  //     for (let i = 0; i < newdayList.length; i++)
  //     {
  //         for (let j = 0; j < newdayList[ i ].TimeFrameList.length; j++)
  //         {
  //             newdayList[ i ].TimeFrameList[ j ].IsSelected = false;
  //         }
  //     }

  //     this.setState({ calendarDayList: newdayList });
  // }

  // WeekOnMouseDown = (e) =>
  // {
  //     this.setState({
  //         selectionStartPosX: e.clientX -  $('#divTimesheet')[0].offsetLeft,
  //         selectionStartPosY: e.clientY - $('#divCalendarWeekRow')[0].offsetTop + window.scrollY,
  //         isSelecting: 1
  //     });

  //     this.ResetTimeFrameSelection();
  //     this.reCalc();
  // };

  // WeekOnMouseMove = (e) =>
  // {
  //     if (this.state.isSelecting !== 1)
  //     {
  //         return;
  //     }
  //     this.setState({
  //         selectionCurrentPosX: e.clientX - $('#divTimesheet')[ 0 ].offsetLeft,
  //         selectionCurrentPosY: e.clientY - $('#divCalendarWeekRow')[ 0 ].offsetTop + window.scrollY
  //     });

  //     if (this.state.isSelecting === 1)
  //     {
  //         $(`#${this.state.selectingSquareDivId}`)[ 0 ].hidden = 0;
  //         this.reCalc();
  //     }
  // };

  // reCalc ()
  // {
  //     const topLeftX = Math.min(this.state.selectionStartPosX, this.state.selectionCurrentPosX);
  //     const topLeftY = Math.min(this.state.selectionStartPosY, this.state.selectionCurrentPosY);
  //     const bottomRightX = Math.max(this.state.selectionStartPosX, this.state.selectionCurrentPosX);
  //     const bottomRightY = Math.max(this.state.selectionStartPosY, this.state.selectionCurrentPosY);

  //     const selectingSquareDiv = $(`#${this.state.selectingSquareDivId}`)[ 0 ];

  //     selectingSquareDiv.style.left = `${topLeftX}px`;
  //     selectingSquareDiv.style.top = `${topLeftY}px`;
  //     selectingSquareDiv.style.width = `${bottomRightX - topLeftX}px`;
  //     selectingSquareDiv.style.height = `${bottomRightY - topLeftY}px`;
  // }

  // isColliding ($div1, $div2)
  // {
  //     // Div 1 data
  //     const d1_offset = $div1.offset();
  //     const d1_height = $div1.outerHeight(true);
  //     const d1_width = $div1.outerWidth(true);
  //     const d1_distance_from_top = d1_offset.top + d1_height;
  //     const d1_distance_from_left = d1_offset.left + d1_width;

  //     // Div 2 data
  //     const d2_offset = $div2.offset();
  //     const d2_height = $div2.outerHeight(true);
  //     const d2_width = $div2.outerWidth(true);
  //     const d2_distance_from_top = d2_offset.top + d2_height;
  //     const d2_distance_from_left = d2_offset.left + d2_width;

  //     const not_colliding = (d1_distance_from_top < d2_offset.top || d1_offset.top > d2_distance_from_top || d1_distance_from_left < d2_offset.left || d1_offset.left > d2_distance_from_left);

  //     // Return whether it IS colliding
  //     return !not_colliding;
  // };
}
